module.exports = __webpack_public_path__ + "static/img/db6_pc.8a762bad.jpg";